import { Icon } from '../../Atoms/Icon';

export interface RelatedRecordsColumn<T> {
  header: string;
  headerClass?: string;
  cellClass?: string;
  text: (record: T) => string;
}

export interface RelatedRecordsTableProps<T> {
  testId: string;
  records: T[];
  recordKey: (record: T) => string;
  columns: RelatedRecordsColumn<T>[];
  openTitle: string;
  onOpen: (record: T) => void;
}

const dividedClass = (index: number, count: number, className?: string) =>
  [index < count - 1 ? 'border-r' : '', className].filter(Boolean).join(' ');

export function RelatedRecordsTable<T>({
  testId,
  records,
  recordKey,
  columns,
  openTitle,
  onOpen
}: RelatedRecordsTableProps<T>) {
  return (
    <table
      data-testid={`${testId}-table`}
      className="w-full table-fixed [&_tr]:border-y">
      <thead>
        <tr className="text-indigo-mid text-xs text-left [&>*]:font-normal [&>*]:p-2">
          <th className="border-r w-12"></th>
          {columns.map((column, index) => (
            <th
              key={column.header}
              className={dividedClass(index, columns.length, column.headerClass)}>
              {column.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {records.map((record) => (
          <tr
            key={recordKey(record)}
            className="text-black text-sm text-left font-normal align-top [&>*]:p-2">
            <td className="border-r">
              <button
                data-testid={`${testId}-detail-cta`}
                title={openTitle}
                className="flex items-center justify-center w-full"
                onClick={() => onOpen(record)}>
                <Icon
                  type="details"
                  className="p-3 cursor-pointer"
                />
              </button>
            </td>
            {columns.map((column, index) => (
              <td
                key={column.header}
                className={dividedClass(index, columns.length, column.cellClass)}
                title={column.text(record)}>
                {column.text(record)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
